import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import _Number$parseFloat from "@babel/runtime-corejs3/core-js/number/parse-float";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { computed, defineComponent, ref, watch, onMounted, onUnmounted, reactive } from "@vue/composition-api";
import * as FieldComponents from "@Shared/components/sections/index";
import { formatMoneyValueLong } from "@Shared/@Utils/helpers/money";
import MortgageCalculatorsToolbar from "./mortgage-calculators-toolbar.vue";
import ReportTabLayout from "@Broker/@Modules/clients/reports/reports-containers/report-tab-layout.vue";
import i18n from "@Shared/i18n";
import { showToast } from "@Shared/@Utils/constants";
import * as FinancialToolsActions from "../store/financial-tools-actions";
import { createNamespacedHelpers } from "vuex-composition-helpers";
const {
  useActions: useFinancialToolsActions
} = createNamespacedHelpers("FinancialToolsStore");
const componentName = "PaymentAnalyzerContainer";
export default defineComponent({
  name: componentName,
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    MortgageCalculatorsToolbar,
    ReportTabLayout
  }),
  setup() {
    const thisComponentCookieString = localStorage.getItem(componentName);
    const thisComponentCookieData = thisComponentCookieString ? JSON.parse(thisComponentCookieString) : {};
    const indata = reactive({
      mortgageAmount: thisComponentCookieData.mortgageAmount || 0,
      interestRate: thisComponentCookieData.interestRate || 0.001,
      amortizPeriod: thisComponentCookieData.amortizPeriod || 25
    });
    const pay = ref({
      Month: -1,
      semiMonth: -1,
      AccelBi: -1,
      AccelWeek: -1,
      BiWeek: -1,
      Week: -1
    });
    const amortiz = ref({
      Month: -1,
      semiMonth: -1,
      AccelBi: -1,
      AccelWeek: -1,
      BiWeek: -1,
      Week: -1
    });
    const errorMessageAmt = computed(() => {
      return indata.mortgageAmount < 10000 || indata.mortgageAmount > 100000000 ? i18n.t("financial-tools.message_missing_question_1").toString() : "";
    });
    const errorMessageRate = computed(() => {
      return indata.interestRate < 0.001 || indata.interestRate > 100.0 ? i18n.t("financial-tools.message_missing_question_2").toString() : "";
    });
    const errorMessagePer = computed(() => {
      return indata.amortizPeriod < 1 || indata.amortizPeriod > 35 ? i18n.t("financial-tools.message_missing_question_3").toString() : "";
    });
    function validateInputs() {
      const fields = [{
        label: i18n.t("financial-tools.mortgage_amount").toString(),
        error: errorMessageAmt.value
      }, {
        label: i18n.t("financial-tools.interest_rate").toString(),
        error: errorMessageRate.value
      }, {
        label: i18n.t("financial-tools.amortization_period").toString(),
        error: errorMessagePer.value
      }];
      let valid = true;
      fields.forEach(({
        label,
        error
      }) => {
        if (error !== "") {
          showToast("error", label + ": " + error);
          valid = false;
        }
      });
      return valid;
    }
    function resetResults() {
      const defaults = {
        Month: -1,
        semiMonth: -1,
        AccelBi: -1,
        AccelWeek: -1,
        BiWeek: -1,
        Week: -1
      };
      pay.value = defaults;
      amortiz.value = defaults;
    }
    function calcAmortMy(payment, nrPays) {
      const MORTGAGE = indata.mortgageAmount;
      const INRATE = indata.interestRate / 100;
      const intfact = Math.pow(1 + INRATE / 2, 2 / nrPays) - 1;
      const monthly = Math.log(payment / (payment - MORTGAGE * intfact)) / Math.log(1 + intfact);
      let result = nrPays / 12.0;
      result = Math.round(monthly / result * 1000) / 1000;
      result = Math.round(result / 12.0 * 10) / 10;
      return result;
    }
    function compPay() {
      const MORTGAGE = indata.mortgageAmount;
      const AMORT = indata.amortizPeriod;
      const INRATE = indata.interestRate / 100;
      if (!validateInputs()) {
        resetResults();
        return false;
      }
      if (indata.mortgageAmount < 0 || indata.interestRate < 0 || indata.amortizPeriod < 0) {
        resetResults();
        return false;
      }
      const compound = 2 / 12;
      const monTime = AMORT * 12;
      const yrRate = INRATE / 2;
      const rdefine = Math.pow(1.0 + yrRate, compound) - 1.0;
      const comfact = Math.pow(1.0 + rdefine, monTime);
      const PAYMNT = MORTGAGE * rdefine * comfact / (comfact - 1.0);
      const rPAYMENT = PAYMNT;
      const rPAYMENT2 = PAYMNT / 2.0;
      const rPAYMENT3 = PAYMNT / 4.0;
      const rPAYMENT4 = PAYMNT * 12.0 / 26.0;
      const rPAYMENT5 = PAYMNT * 12.0 / 52.0;
      pay.value = {
        Month: rPAYMENT,
        semiMonth: rPAYMENT2,
        AccelBi: rPAYMENT2,
        AccelWeek: rPAYMENT3,
        BiWeek: rPAYMENT4,
        Week: rPAYMENT5
      };
      amortiz.value = {
        Month: indata.amortizPeriod,
        semiMonth: calcAmortMy(rPAYMENT2, 24),
        AccelBi: calcAmortMy(rPAYMENT2, 26),
        AccelWeek: calcAmortMy(rPAYMENT3, 52),
        BiWeek: calcAmortMy(rPAYMENT4, 26),
        Week: calcAmortMy(rPAYMENT5, 52)
      };
      return true;
    }
    watch(indata, () => {
      if (errorMessageAmt.value || errorMessageRate.value || errorMessagePer.value) {
        resetResults();
      }
    }, {
      immediate: true
    });
    const handleClearSelection = () => {
      indata.mortgageAmount = 0;
      indata.interestRate = 0.001;
      indata.amortizPeriod = 25;
    };
    onMounted(() => {
      $("[name='mortgageAmount']").trigger("focus");
    });
    onUnmounted(() => {
      localStorage.setItem(componentName, _JSON$stringify(indata));
    });
    function formatMoney(val) {
      return val && val > 0 ? formatMoneyValueLong(val) : "-";
    }
    function formatVal(val) {
      return val && val > 0 ? val.toLocaleString(this.$root.$i18n.locale, {}) : "-";
    }
    const {
      PRINT_PAYMENT_ANALYZER_FORM
    } = useFinancialToolsActions([FinancialToolsActions.PRINT_PAYMENT_ANALYZER_FORM]);
    const isLoading = ref(false);
    const runReport = async () => {
      if (!compPay()) return;
      isLoading.value = true;
      const pv = pay.value;
      const am = amortiz.value;
      const data = {
        mortgageAmount: _Number$parseFloat(indata.mortgageAmount),
        interestRate: _Number$parseFloat(indata.interestRate),
        amortization: _Number$parseFloat(indata.amortizPeriod),
        table: {
          payments: [pv.Month, pv.semiMonth, pv.BiWeek, pv.AccelBi, pv.Week, pv.AccelWeek],
          amortizations: [am.Month, am.semiMonth, am.BiWeek, am.AccelBi, am.Week, am.AccelWeek]
        }
      };
      try {
        await PRINT_PAYMENT_ANALYZER_FORM({
          data
        });
      } catch (e) {
        console.error(e);
      }
      isLoading.value = false;
    };
    return {
      indata,
      pay,
      amortiz,
      errorMessageAmt,
      errorMessageRate,
      errorMessagePer,
      formatMoney,
      formatVal,
      compPay,
      handleClearSelection,
      runReport,
      isLoading
    };
  }
});